import { render, staticRenderFns } from "./community-manage.vue?vue&type=template&id=c89eb28a&scoped=true&"
import script from "./community-manage.vue?vue&type=script&lang=js&"
export * from "./community-manage.vue?vue&type=script&lang=js&"
import style0 from "./community-manage.vue?vue&type=style&index=0&id=c89eb28a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89eb28a",
  null
  
)

export default component.exports